<template>
    <SOSlotModal  
        modal-title="Konfirmasi Ambil Layanan"
        :modal-id="id"
        :no-padding="true"
        @close="notConfirm()"
    >
        <template v-slot:modal-body>
            <div class="px-4 pt-4">
                <div>
                   <b>{{data.total}} Transaksi belum diambil </b> pada invoice ini : 
                </div>
                <div>
                    <div class="f-16">
                        <ul>
                            <li v-if="data.belum_selesai">
                                <b>{{data.belum_selesai}} transaksi Belum selesai</b>
                            </li>
                            <li v-if="data.belum_diambil">
                                <b>{{data.belum_diambil}} transaksi belum selesai, belum diambil*</b> 
                            </li>
                        </ul>
                        <div>
                            Klik “Bayar & Ambil” untuk membayar invoice sekaligus memproses penyelesaian & pengambilan transaksi.
                        </div>
                    </div>
                    <div class="f-14 mt-2">
                        *termasuk transaksi yang diambil sebagian
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="px-4 pb-4">
                <SOButton
                    text="Bayar & Ambil"
                    :primary="true"
                    :full="true"
                    @action="confirm(true)"
                />
                <SOButton
                    text="Bayar Saja"
                    outline
                    :full="true"
                    @action="confirm(false)"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "confirmModal",
    components: {
        SOSlotModal,
        SOButton,
    },
    props: {
        title: {
            type: String,
            default: "Konfirmasi Ambil Layanan",
        },
    },
    data () {
        return {
            id:"confirm-lunasi-modal",
            requestChange: null,
            resolve: null,
            reject: null,
            data: {},
        }
    },
    methods: {
        open(data) {
            this.data = data
            return new Promise((resolve, reject)=>{
                this.resolve = resolve
                this.reject = reject
                $("#" + this.id).modal("show");
            })
        },
        confirm(is_with_ambil) {
            this.resolve(is_with_ambil)
            this.close()
        },
        notConfirm() {
            this.reject()
            this.close()
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
    },
}
</script>